import * as types from "../../mutation-types";
import ShopsProvider from "../../../providers/ShopsProvider";
// eslint-disable-next-line no-unused-vars
const uuid = require("uuid/v4");
// initial state
const state = {
	shops: []
};

// getters
const getters = {
	shops: state => state.shops
};

// actions
const actions = {
	refreshShops({commit, getters}, onlyActive = true) {
		return 	ShopsProvider.findAll(getters.jwtToken, onlyActive).then(response => {
			return commit(types.REFRESH_SHOPS, response);
		});
	},
	async updateShop({dispatch, getters}, shop){
		const updatedShop = await ShopsProvider.update(shop.id, shop, {authToken: getters.jwtToken});

		if(updatedShop.status === 200){
			await dispatch("updateShopRefreshToken", shop.id);
		}

		return dispatch("refreshShops");
	},
	async updateShopRefreshToken({getters, dispatch}, shopId) {
		const shopRefreshTokens = getters.tenantSettings
			&& getters.tenantSettings.shopRefreshTokens
			? {...getters.tenantSettings.shopRefreshTokens}
			: {};
		shopRefreshTokens[shopId] = uuid();
		return dispatch("updateServerData", {
			settingName: "shopRefreshTokens",
			settingValue: shopRefreshTokens
		});
	},
	async updateAllShopRefreshTokens({ getters, dispatch }, uuid) {
		const shops = await ShopsProvider.findAll(getters.jwtToken);
		const shopIds = shops.data.map(shop => shop.id);
		const shopRefreshTokens = Object.keys(shopIds).reduce((acc, key) => {
			acc[shopIds[key]] = uuid;
			return acc;
		}, {});
		return dispatch("updateServerData", {
			settingName: "shopRefreshTokens",
			settingValue: shopRefreshTokens
		});
	},
	[types.SET_SHOPS]: ({commit}, data) => {
		commit(types.SET_SHOPS, data);
	}
};

// mutations
const mutations = {
	[types.REFRESH_SHOPS](state, response) {
		state.shops = response.data.slice();
	},
	[types.SET_SHOPS](state, data) {
		state.shops = data;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
